// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import React, { useEffect, useState } from 'react';
import { Divider, Typography, Button } from '@mui/material';
import { Box, useTheme } from '@mui/system';
import stylesDef from './styles';
import { useAppDispatch, useAppSelector } from 'Hooks';
import { GetGlobalStatusThunk, GetOpsCreditCapacityThunk, UpdateGlobalStatusThunk } from 'Features/globalStatus/globalStatusThunk';
import { credits } from 'Utils/numberFormat';


// A daily figure the way the page prints it, or "Not set" when the server has none
const perDay = (value?: number | null): string => (typeof value === 'number' && Number.isFinite(value) ? `${credits(value)} credits per day` : 'Not set');

export const AccountOpsSettings = () => {
  const theme = useTheme();
  const styles = stylesDef(theme);
  const dispatch = useAppDispatch();
  const { allowExpeditedProcess, dailyCreditCommitment, opsDailyCreditCapacity } = useAppSelector((state) => state.globalStatus.status);

  const [allowExpedited, setAllowExpedited] = useState(false);

  useEffect(() => {
    const loadData = async () => {
      await dispatch(GetOpsCreditCapacityThunk());
      await dispatch(GetGlobalStatusThunk());
    };
    loadData();
  }, []);

  useEffect(() => {
    setAllowExpedited(allowExpeditedProcess);
  }, [allowExpeditedProcess]);

  const setAllowExpeditedProcess = async (value: boolean) => {
    setAllowExpedited(value);
    await dispatch(UpdateGlobalStatusThunk(value));
  };

  return (
    <Box sx={styles.pageWrapper}>
      <Typography variant="h2">Operations Settings</Typography>
      <Divider sx={styles.divider} />
      <Box sx={styles.settingWrapper}>
        <Typography variant="h4">Allow Expedited Processing</Typography>
        <Box>          
      <Button
        sx={{
          color: allowExpedited ? 'primary' : 'inherit', 
        }}
        onClick={() => setAllowExpeditedProcess(true)}
      >
        Yes
      </Button>
      {' '}
      /
      {' '}
      <Button
        sx={{
          color: !allowExpedited ? 'primary' : 'inherit', // Set 'primary' for false, 'inherit' for true
        }}
        onClick={() => setAllowExpeditedProcess(false)}
      >
        No
      </Button>
    </Box>
      </Box>
      <Box>
        <Divider sx={styles.divider} />
        <Box sx={styles.settingWrapper}>
          <Typography variant="h4">Ops Credit Capacity</Typography>
          <Box sx={styles.capacityLines}>
            <Box>
              <Typography variant="h6">{`Committed: ${perDay(dailyCreditCommitment)}`}</Typography>
              <Typography variant="body2" sx={styles.capacityCaption}>Open orders&apos; credits, spread over the days until the last one is due</Typography>
            </Box>
            <Box>
              <Typography variant="h6">{`Capacity: ${perDay(opsDailyCreditCapacity)}`}</Typography>
              <Typography variant="body2" sx={styles.capacityCaption}>Expedited Delivery is offered while an order fits under this. Set by engineering, not here.</Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default AccountOpsSettings;
